module.exports = __webpack_public_path__ + "img/partner4.4687a1d9.png";